import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useReclaimAccessDefaults } from "../../payments/chargebacks/use-reclaim-access-defaults";
import { useSetupGuideOptional } from "../../setup-guide/provider/use-setup-guide";
import { OnboardingProps } from "../common";
import reclaimAnnouncementUrl from "./reclaim-announcement.png?url";

export const ReclaimAnnouncementOnboarding = memo(
  function ReclaimAnnouncementOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const routes = useRequiredContext(MerchantRoutesContext);
    const navigate = useNavigate();
    const setupGuide = useSetupGuideOptional();
    const { termsCopy } = useReclaimAccessDefaults();

    // Hide the card if the merchant already has a setup-guide row for
    // disputes (they've engaged with the new flow). Also hide while the
    // setup-guide context is still loading to prevent a brief flash of
    // the card before it disappears once data arrives.
    if (setupGuide) {
      if (setupGuide.loading) {
        return null;
      }
      if (setupGuide.progressByProduct.disputes != null) {
        return null;
      }
    }

    const handleAction = () => {
      // When the setup-guide flag is on, route through the new entry path
      // so the provider creates a row + opens the intake modal.
      if (setupGuide) {
        navigate(`${routes.chargebacksOverviewHref}?setupSource=homepage_card`);
      } else {
        navigate(routes.chargebacksHref);
      }
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText={termsCopy.cta}
        description={termsCopy.announcementDescription}
        image={reclaimAnnouncementUrl}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Recover chargeback revenue with Reclaim"
      />
    );
  },
);
